package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.AddressToFix
import com.milta.feature.route.domain.entity.GeocodeFailureReason
import com.milta.feature.route.domain.entity.toGeocodeFailureReason
import kotlinx.serialization.Serializable

/**
 * Body of the 422 `error.route.addresses_to_fix` (ProblemDetails extensions flattened at the root,
 * like [com.milta.feature.auth.data.remote.dto.ApiError]). [deliveries] is absent on an older back.
 */
@Serializable
data class AddressesToFixErrorDto(
    val code: String? = null,
    val deliveries: List<AddressToFixDto>? = null,
)

/** [index] = position in the `deliveries` array sent; [reason] = `MissingHouseNumber` |
 * `NotFound` | `ServiceUnavailable`. */
@Serializable
data class AddressToFixDto(
    val index: Int,
    val reason: String? = null,
)

/** An unknown motif still blocks the delivery, shown as "Adresse introuvable" (same as a Failed
 * status without reason). */
fun AddressToFixDto.toDomain() = AddressToFix(index, reason.toGeocodeFailureReason() ?: GeocodeFailureReason.NotFound)
